/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
interface WindowWithIma {
  google: {
    ima: typeof google.ima;
  };
}

const SDK_URL = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
let pendingPromise: Promise<typeof google.ima> | null = null;

const loadScript = (src: string): Promise<Event> =>
  new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });

const promiseFinished = () => {
  pendingPromise = null;
};

export const loadIMALib = (): Promise<typeof google.ima> => {
  const w = window as unknown as WindowWithIma;

  // already loaded
  if (w.google && w.google.ima) {
    return Promise.resolve(w.google.ima);
  }

  // loading in progress
  if (pendingPromise) {
    return pendingPromise;
  }

  // create new loader
  pendingPromise = loadScript(SDK_URL).then(() => w.google.ima);
  pendingPromise.then(promiseFinished).catch(promiseFinished);

  return pendingPromise;
};
